import React, { FC, PropsWithChildren, useEffect, useState } from 'react';
import { useFeatureFlags } from '@funtech-int/yango-shared';

import { HTMLRequestSender } from '@kinopoisk-int/ott-player-tracker/dist/lib/HTMLRequestSender';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';
import { useLogger } from '@/shared/hooks/useLogger';
import { useProfileManager } from '@/shared/hooks/useProfileManager';

import { featureFlagsScheme } from '../../../../lib/featureFlags';

import { createNewPlayerTracker } from './utils';
import { PlayerTrackerContext, PlayerTrackerContextValue } from './context';

const DEBUG_PARAM = '_kp_debug';

export const PlayerTracker: FC<PropsWithChildren> = ({ children }) => {
    const instance = usePlayerInstance();
    const [playerTracker, setPlayerTracker] = useState<PlayerTrackerContextValue>({
        tracker: null,
        sender: null,
    });

    const profileManager = useProfileManager();

    const { testIds } = useFeatureFlags(featureFlagsScheme);

    const logger = useLogger();

    useEffect(() => {
        if (playerTracker.tracker || !instance) {
            return;
        }

        const htmlSender = new HTMLRequestSender({
            debug: document.cookie.includes(`${DEBUG_PARAM}=`),
            getIsSendBeaconAllowed: () => true,
        });

        setPlayerTracker({
            tracker: createNewPlayerTracker(instance, htmlSender),
            sender: {
                type: 'old',
                htmlRequest: htmlSender,
            },
        });
    }, [instance, playerTracker, testIds, logger, profileManager]);

    return (
        <PlayerTrackerContext.Provider value={playerTracker}>
            {children}
        </PlayerTrackerContext.Provider>
    );
};
